module.exports = __webpack_public_path__ + "static/media/img_Benchmarking203.f74f6709.png";